import { AccountType, IAccount } from "./account/IAccount";
import { IDocument } from "./Document";
import { BaseEntity, DefaultResponseWithData } from "./system";

export interface ISingleContactRespose
  extends DefaultResponseWithData<IContact> { }
export interface IAllContactsResponse
  extends DefaultResponseWithData<IContact[]> { }

export enum ContactType {
  Customer,
  Supplier,
  Staff,
  Driver,
  Admin,
  Mechanic,
  Exporter,
}

export interface IContact extends BaseEntity {
  contactType: ContactType;
  fullname: string;
  telephone1: string;
  telephone2: string;
  email: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  locality: string;
  town: string;
  county: string;
  postcode: string;
  notes: string;
  ebayUsername: string;

  deleted: string | null;

  accountId?: string;
  account: IAccount | null;

  documents: IDocument[];

  //Frontend only
  hasDocuments: boolean;
}

export interface ContactCreateEditRequest
  extends Omit<
    IContact,
    "created" | "updated" | "deleted" | "ebayUsername" | "accountId"
  > {
  createAccountQuery?: boolean;
  accountName: string | null;
  bankAccountName: string | null;
  bankAccountNumber: string | null;
  bankSortCode: string | null;
  accountType: AccountType;

  createAccount?: boolean;
}

